import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isTokenExpired = this.authService.isTokenExpired();

    const url = req.url;

    //if (url.includes('/api/product')) {
    //  console.log('🛒 Cart API request detected:', url);
    //} else if (url.includes('/api/categories/tree')) {
    //  console.log('📦 Vendor API request detected:', url);
    //} else {
    //  console.log('🌐 General API request:', url);
    //}

    if (!isTokenExpired) {
      const cloned = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${this.authService.getToken()}`)
      });
      return next.handle(cloned);
    }
    else if (!url.includes('/api/product') &&
      !url.includes('/api/categories/tree') &&
      !url.includes('/api/auth') &&
      !url.includes('/api/Vendors/Register'))
    {
      this.authService.logout();
      this.router.navigate(['/login']);
    }


    return next.handle(req);
    //return next.handle(req).pipe(

    //  catchError((error: HttpErrorResponse) => {
    //    if (error.status != 200 &&
    //      this.authService.isTokenExpired() &&
    //      !url.includes('/api/product') && 
    //      !url.includes('/api/categories/tree')) {
    //      this.authService.logout();
    //      this.router.navigate(['/login']);
    //    }
    //    return throwError(() => error);
    //  })
    //);
  }
}
